import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldNumber from '../../../atoms/FromFieldNumber';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import FromFieldSelect from '../../../atoms/FromFieldSelect';
import FromSpFieldText from '../../../atoms/FromSpFieldText';
import "./SingleAsset.css";
import './SingleAsset.css';
import { saveCapitalize, getSingleCapitalize, searchSingleCapitalize, getCountCinNo, getSumPercentDisposal } from '../../../services/asset.service';
import { getClasificationsList } from '../../../services/user.service';
import * as CryptoJS from "crypto-js";

Date.prototype.dbFormatedDate = function () {
  let year = this.getFullYear();
  let month = this.getMonth() + 1;
  let day = this.getDate();
  if (month < 10) {
    month = '0' + month;
  } if (day < 10) {
    day = '0' + day;
  }
  return year + '-' + month + '-' + day;
}
function getFormatedDate(dateString) {
  if (dateString !== null) {
    let dte = new Date(dateString);
    let year = dte.getFullYear();
    let month = dte.getMonth() + 1;
    let day = dte.getDate();
    if (month < 10) {
      month = '0' + month;
    } if (day < 10) {
      day = '0' + day;
    }
    return year + '-' + month + '-' + day;
    //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
  } else {
    return null;
  }
}

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;
const TEXT_SPCL_REGEX = /^[A-Za-z0-9-_.,\/\[\]\-()"'+&'%$#@*!= ]{1,500}$/;
const NUMBER_REGEX = /^[0-9]{1,15}$/;

function SACapForm() {
  const [tag, setTag] = useState('');
  const [parentTag, setParentTag] = useState('');
  const [capitalizeInfo, setAssetInfo] = useState([]);

  const [ErrTAG, setErrTag] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);

  const [classOfAsset, setClassOfAsset] = useState('');
  const [ErrClassOfAsset, setErrClassOfAsset] = useState(false);

  const [puttousedate, setPutToUseDate] = useState('');
  const [ErrPutToUseDate, setErrPutToUseDate] = useState('');

  const [indAsEffectiveDate, setIndAsEffectiveDate] = useState('');
  const [ErrIndAsEffectiveDate, setErrIndAsEffectiveDate] = useState('');

  const [assetinusedate, setAssetInuseDate] = useState('');
  const [ErrAssetInuseDate, setErrAssetInuseDate] = useState('');

  const [ErrDepreciationType, setErrDepreciationType] = useState(false);
  const [depreciationtype, setTypeOfDepreciation] = useState('');
  const [depreciationrate, setDepreciationRate] = useState('');
  const [ErrDepreciationRate, setErrDepreciationRate] = useState(false);
  const [otherdepreciationrate, setOtherDepreciationRate] = useState('');
  const [ErrOtherDepreciationRate, setErrOtherDepreciationRate] = useState(false);
  const [assettype, setTypeOfAsset] = useState('UseParent');
  const [ErrTypeOfAsset, setErrTypeOfAsset] = useState(false);
  const [assetcode, setassetcode] = useState('');

  const [assetac, setassetac] = useState('');
  const [ErrAssetAc, setErrAssetAc] = useState(false);

  const [fnclassification, setfnclassification] = useState('');
  const [ErrFnClassification, setErrFnClassification] = useState(false);
  const [clearDepreciation, setClearDepreciation] = useState(false);

  const [recordstartdate, setRecordStartDate] = useState('');
  const [oldrecordstartdate, setOldRecordStartDate] = useState('');
  const [ErrRecordStartDate, setErrRecordStartDate] = useState('');
  const [otherrecordstartdate, setOtherRecordStartDate] = useState('');
  const [ErrOtherRecordStartDate, setErrOtherRecordStartDate] = useState('');
  const [finalAsset, setFinalAsset] = useState('');
  const [ErrFinalAsset, setErrFinalAsset] = useState(false);

  const [isTaxCapitalized, setIsTaxCapitalized] = useState('');
  const [ErrIsTaxCap, setErrIsTaxCap] = useState(false);
  const [invoicecurrency, setInvoiceCurrency] = useState('');
  const [exchangerate, setexchangerate] = useState('');
  const [ErrExchangeRate, setErrExchangeRate] = useState(false);

  const [is100PercDepreciable, setIs100PercDepreciable] = useState('');
  const [ErrIs100PercDep, setErrIs100PercDep] = useState(false);
  const [is100PercOtherDepreciable, setIs100PercOtherDepreciable] = useState('');
  const [ErrIs100PercOthDep, setErrIs100PercOthDep] = useState(false);

  const [preCapitalizedAssetValue, setPreCapitalizedAssetValue] = useState('');
  const [preCapitalizedAssetValue_tmp, setPreCapitalizedAssetValue_tmp] = useState('');
  const [ErrPreCapAsVal, setErrPreCapAsVal] = useState(false);

  const [isAnyOtherAccgGaapApplicable, setIsAnyOtherAccgGaapApplicable] = useState();
  const [ErrIsAnyOtAcGaApp, setErrIsAnyOtAcGaApp] = useState(false);

  const [igaapLimitAmount, setIgaapLimitAmount] = useState('');
  const [ErrIgaapLimitAmount, setErrIgaapLimitAmount] = useState(false);

  const [othergaapLimitAmount, setOthergaapLimitAmount] = useState('');
  const [ErrOthergaapLimitAmount, setErrOthergaapLimitAmount] = useState(false);

  const [salvageValue, setSalvageValue] = useState('');
  const [ErrSalvageValue, setErrSalvageValue] = useState(false);

  const [iGaapCapitalizedValue, setIGaapCapitalizedValue] = useState('');
  const [ErrIGaCapValue, setErrIGaCapValue] = useState(false);
  const [deemedCost, setDeemedCost] = useState(0);
  const [ErrDeemedCost, setErrDeemedCost] = useState(false);
  const [totalcostwithouttax, setTotalCostWithoutTax] = useState('');
  const [totalcostwithouttax_tmp, setTotalCostWithoutTax_tmp] = useState('');
  //const [compRefNo,setCompRefNo] = useState('');
  //const [ErrCompRefNo, setErrCompRefNo] = useState(false);

  const [othergaapCapitalizedValue, setOthergaapCapitalizedValue] = useState('');
  const [ErrOthGaCaptValue, setErrOthGaCaptValue] = useState(false);
  const [typeofDepShow, setTypeofDepShow] = useState(false);
  const [assetenddate, setAssetEndDate] = useState();
  const [assetotherenddate, setAssetOtherEndDate] = useState();
  const [preDepType, setPreDepType] = useState('');
  //const [valuewithtax, setValueWithTax] = useState('');
  const [capitalization_status, setCapitalizationStatus] = useState('');
  //const errRef = useRef();
  const [valueofasset, setValueofAsset] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showOtherVal, setShowOtherVal] = useState('');
  const [allreadOnly, setAllReadOnly] = useState(false);
  const [CoaReadOnly, setCoaReadOnly] = useState(false);
  const [CINAndRef, setCINAndRef] = useState('');
  const [PrefixCINAndRef, setPrefixCINAndRef] = useState('');
  /*const setCustomValue= function(test){
    alert(test);
  }*/
  const [classifications, setClasifications] = useState([]);
  //const [classification, setClasification] = useState([]);
  const [auditInfo, setAuditInfo] = useState([]);

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const Tag = query.get('tag');
  const Mode = query.get('mode');
  const Exception = query.get('exception') ?? '';
  const Dispose = query.get('dispose') ?? '';
  //const elementRef = useRef();
  useEffect(() => {
    if (Tag != '' && Tag != null) {
      const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
      // Convert the decrypted bytes to a string
      const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      const decryptedTagId = decrypt_data.tag;
      const decryptedSlNoId = decrypt_data.sl_no;

      getTagCapInfo(decryptedTagId, decryptedSlNoId, Exception, Dispose);
      //setAllReadOnly(true);
    } else {  // means insert new capitalization
      generateCINAndRef(-1);
    }


    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'param_data': { 'company_id': sessionStorage.getItem('company_id') },
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = { 'token': EncryptData };
    getClasificationsList(oData).then(res => {
      if (res?.data?.data?.length) setClasifications(res.data.data);
    });
    //alert(PrefixCINAndRef);
    if (PrefixCINAndRef) {
      let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': { 'cin_no': PrefixCINAndRef },
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData1 = { 'token': EncryptData1 };
      getCountCinNo(oData1).then(res => {
        //setClasifications(res.data.data);
        generateCINAndRef(res?.data?.total);
      });
    }
  }, [PrefixCINAndRef]);

  const generateCINAndRef = function (lastNumber = '') {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // zero-padded month
    const year = String(date.getFullYear()).slice(-2);          // last 2 digits of year
    const divisionCode = sessionStorage.getItem('LoggedInDivisionCode') || '0000';
    const nextSerial = String(lastNumber + 1).padStart(5, '0'); // e.g., 00001
    if (lastNumber < 0) {
      let precinCode = `CIN${divisionCode}${month}${year}`;
      //alert(precinCode);
      setPrefixCINAndRef(precinCode);
    } else {
      let cinCode = `CIN${divisionCode}${month}${year}${nextSerial}`;
      setCINAndRef(cinCode);
    }
    //const refTag = `${nextSerial}-1`;
  };
  const generateSubCINAndRef = function (cinCode) {
    if (typeof cinCode === 'string' && cinCode.trim() !== '') {
      // Extract base CIN (before any dash)
      const baseCIN = cinCode.split('-')[0];
      let EncryptData2 = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': { 'cin_no': baseCIN, 'company_id': sessionStorage.getItem('company_id') },
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData2 = { 'token': EncryptData2 };
      getCountCinNo(oData2).then(res => { //console.log(res?.data?.total);
        const count = res?.data?.total || 0;
        const suffix = Math.max(1, count);
        let sub_cinCode = `${baseCIN}-${suffix}`;
        //alert(cinCode);
        setCINAndRef(sub_cinCode);
      });
    }
    //const refTag = `${nextSerial}-1`;
  };
  const getTagCapInfo = async (decryptedTagId, decryptedSlNoId, Exception = '', Dispose = '') => {
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'param_data': { 'tag': decryptedTagId, 'sl_no': decryptedSlNoId },
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData1 = { 'token': EncryptData }

    //getSingleCapitalize(oData1).then(function(res){ 
    const res = await getSingleCapitalize(oData1);
    var { capitalizeInfo, capitalizeInfo } = {};
    if (res?.data?.data) {
      var { capitalizeInfo, capitalizeInfo } = res.data.data;
      setOldAssetauditInfo(capitalizeInfo);
      if (capitalizeInfo.tag) {
        //var useInDate = new Date(capitalizeInfo.asset_in_use_date);
        //console.log(capitalizeInfo);
        //setCINAndRef(''); alert('Te'+capitalizeInfo.cin_no);
        setCINAndRef(capitalizeInfo.cin_no);
        generateSubCINAndRef(capitalizeInfo.cin_no);
        setTypeofDepShow(true);
        setTag(capitalizeInfo.tag);
        setAssetInfo(capitalizeInfo);
        //check if asset come from pre exception and dispose
        //alert('test1');alert(capitalizeInfo.value_of_asset);

        if (Dispose == 'yes') {
          let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': capitalizeInfo.tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
          }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
          let oData2 = { 'token': EncryptData }
          const res3 = await getSumPercentDisposal(oData2);
          //getSumPercentDisposal(oData2).then(function(res3){
          if (res3?.data?.data) {
            let asset_disposal_value = parseFloat(res3?.data?.data[0].asset_disposal_value);
            //alert(asset_disposal_value);
            let new_value_of_asset = (parseFloat(capitalizeInfo.value_of_asset).toFixed(2) - parseFloat((parseFloat(capitalizeInfo.value_of_asset).toFixed(2) * (asset_disposal_value / 100)).toFixed(2)));
            //var newupdated = {...capitalizeInfo};
            capitalizeInfo.value_of_asset = new_value_of_asset;

            //setAssetInfo(newupdated);
            //alert(capitalizeInfo.value_of_asset );
          }
          //});
        }
        //Check for child element
        //alert('test2');alert(capitalizeInfo.value_of_asset);
        if (capitalizeInfo.parent_tag) {
          setParentTag(capitalizeInfo.parent_tag);
          let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': capitalizeInfo.parent_tag, 'sl_no': capitalizeInfo.sl_no },
            'authToken': sessionStorage.getItem('LoggedInToken'),
          }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
          let oData2 = { 'token': EncryptData }
          getSingleCapitalize(oData2).then(function (res2) {
            if (res2?.data?.data) {
              var assetInfo2 = res2.data.data.capitalizeInfo;
              if (capitalizeInfo.cap_type_of_asset == "UseParent") {
                setAssetInuseDate(assetInfo2.asset_in_use_date ? (new Date(new Date(assetInfo2.asset_in_use_date))) : '');
                setRecordStartDate(assetInfo2.record_start_date ? (new Date(new Date(assetInfo2.record_start_date))) : '');
                setOldRecordStartDate(assetInfo2.record_start_date ? (new Date(new Date(assetInfo2.record_start_date))) : '');
                setOtherRecordStartDate(assetInfo2.other_record_start_date ? (new Date(new Date(assetInfo2.other_record_start_date))) : '');
                setPutToUseDate(assetInfo2.put_to_use_date ? (new Date(new Date(assetInfo2.put_to_use_date))) : '');
              } else {
                setAssetInuseDate(capitalizeInfo.asset_in_use_date ? (new Date(new Date(capitalizeInfo.asset_in_use_date))) : '');
                setRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
                setOldRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
                setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (new Date(new Date(capitalizeInfo.other_record_start_date))) : '');
                setPutToUseDate(capitalizeInfo.put_to_use_date ? (new Date(new Date(capitalizeInfo.put_to_use_date))) : '');
              }
              var asset_end_date = new Date(assetInfo2.asset_in_use_date);
              var assetend_date = new Date(asset_end_date.setFullYear(asset_end_date.getFullYear() + assetInfo2.depreciation_rate));
              var assetenddate = new Date(assetend_date.setDate(assetend_date.getDate() - 1));
              //console.log(assetenddate);
              setAssetEndDate(getFormatedDate(assetenddate));
              setAssetOtherEndDate(getFormatedDate(assetotherenddate));
              setDepreciationRate(assetInfo2.depreciation_rate);
              setOtherDepreciationRate(assetInfo2.other_depreciation_rate);
              setPreDepType(assetInfo2.type_of_depreciation);
              setTypeOfDepreciation(assetInfo2.type_of_depreciation);
              setClassOfAsset(capitalizeInfo.class_of_asset ? assetInfo2.class_of_asset : '');
              setassetcode(capitalizeInfo.accounting_code ? assetInfo2.accounting_code : '');
              setassetac(capitalizeInfo.accounting_name ? assetInfo2.accounting_name : '');
              setfnclassification(assetInfo2.financials_classification);
              //parent value

              setTotalCostWithoutTax(capitalizeInfo.total_cost_without_tax ? parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2) : parseFloat(assetInfo2.total_cost_without_tax).toFixed(2));
              setTotalCostWithoutTax_tmp(capitalizeInfo.total_cost_without_tax ? parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2) : parseFloat(assetInfo2.total_cost_without_tax).toFixed(2));

              if (capitalizeInfo.is_tax_capitalized == 'No') {
                setPreCapitalizedAssetValue(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
                setPreCapitalizedAssetValue_tmp(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
                setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value ? capitalizeInfo.igaap_capitalized_value : capitalizeInfo.total_cost_without_tax).toFixed(2));
              } else {
                setPreCapitalizedAssetValue((parseFloat(capitalizeInfo.value_of_asset)) * (parseFloat(capitalizeInfo.cap_exchange_rate ? capitalizeInfo.cap_exchange_rate : capitalizeInfo.exchange_rate).toFixed(2)));
                setPreCapitalizedAssetValue_tmp(capitalizeInfo.value_of_asset ? parseFloat(capitalizeInfo.value_of_asset).toFixed(2) : parseFloat(assetInfo2.value_of_asset).toFixed(2));
                setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value).toFixed(2));
              }
            }
          });
        } else {  //alert('test3');alert(capitalizeInfo.value_of_asset);
          setAssetInuseDate(capitalizeInfo.asset_in_use_date ? (new Date(new Date(capitalizeInfo.asset_in_use_date))) : '');
          setRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
          setOldRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
          setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (new Date(new Date(capitalizeInfo.other_record_start_date))) : '');
          setPutToUseDate(capitalizeInfo.put_to_use_date ? (new Date(new Date(capitalizeInfo.put_to_use_date))) : '');
          setAssetEndDate(capitalizeInfo.depreciation_end_date ? (getFormatedDate(new Date(capitalizeInfo.depreciation_end_date))) : '');
          setAssetOtherEndDate(capitalizeInfo.depreciation_other_end_date ? (getFormatedDate(new Date(capitalizeInfo.depreciation_other_end_date))) : '');
          setDepreciationRate(capitalizeInfo.depreciation_rate);
          setOtherDepreciationRate(capitalizeInfo.other_depreciation_rate);
          setPreDepType(capitalizeInfo.type_of_depreciation);
          setTypeOfDepreciation(capitalizeInfo.type_of_depreciation);
          setClassOfAsset(capitalizeInfo.class_of_asset);
          setassetcode(capitalizeInfo.accounting_code);
          setassetac(capitalizeInfo.accounting_name);
          setfnclassification(capitalizeInfo.financials_classification);

          setTotalCostWithoutTax(parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2));
          setTotalCostWithoutTax_tmp(parseFloat(capitalizeInfo.total_cost_without_tax).toFixed(2));
          //alert(capitalizeInfo.is_tax_capitalized);
          if (capitalizeInfo.is_tax_capitalized == 'No') {
            setPreCapitalizedAssetValue(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
            setPreCapitalizedAssetValue_tmp(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
            setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value ? capitalizeInfo.igaap_capitalized_value : capitalizeInfo.total_cost_without_tax).toFixed(2));
          } else {
            setPreCapitalizedAssetValue(parseFloat(capitalizeInfo.value_of_asset).toFixed(2));
            setPreCapitalizedAssetValue_tmp(parseFloat(capitalizeInfo.value_of_asset).toFixed(2));
            setIGaapCapitalizedValue(parseFloat(capitalizeInfo.igaap_capitalized_value).toFixed(2));
          }
        } //alert(capitalizeInfo.cin_no);
        setCINAndRef(capitalizeInfo.cin_no);
        setTypeOfAsset(capitalizeInfo.cap_type_of_asset);
        setFinalAsset(capitalizeInfo.capitalization_flag);
        setIsTaxCapitalized(capitalizeInfo.is_tax_capitalized);
        setInvoiceCurrency(capitalizeInfo.invoice_currency);
        setexchangerate(capitalizeInfo.cap_exchange_rate ? parseFloat(capitalizeInfo.cap_exchange_rate).toFixed(2) : parseFloat(capitalizeInfo.exchange_rate).toFixed(2));
        setIs100PercDepreciable(capitalizeInfo.is_100_perc_depreciable);
        setIs100PercOtherDepreciable(capitalizeInfo.is_100_perc_other_depreciable);
        setIsAnyOtherAccgGaapApplicable(capitalizeInfo.is_any_other_accg_gaap_applicable);
        setShowOtherVal(capitalizeInfo.is_any_other_accg_gaap_applicable);
        setIgaapLimitAmount(parseFloat(capitalizeInfo.igaap_limit_amount).toFixed(2));
        setOthergaapLimitAmount(parseFloat(capitalizeInfo.othergaap_limit_amount).toFixed(2));
        setSalvageValue(parseFloat(capitalizeInfo.salvage_value).toFixed(2));
        setOthergaapCapitalizedValue(parseFloat(capitalizeInfo.othergaap_capitalized_value).toFixed(2));
        setCapitalizationStatus(capitalizeInfo.capitalization_status);

        setValueofAsset(parseFloat(capitalizeInfo.value_of_asset).toFixed(2));
        //setCINAndRef(capitalizeInfo.cin_no);
        //alert(capitalizeInfo.value_of_asset);
        setDeemedCost(parseFloat(capitalizeInfo.deemed_cost || 0).toFixed(2));
        setIndAsEffectiveDate(capitalizeInfo.indas_effective_date ? (new Date(new Date(capitalizeInfo.indas_effective_date))) : '');
        if (Dispose == 'yes') {
          setRecordStartDate('');
        }
        if (capitalizeInfo.class_of_asset != 'Capitalized') {
          setAllReadOnly(true);
          setCoaReadOnly(false);
        } else { setAllReadOnly(false); }

      } //alert(capitalizeInfo.value_of_asset);
    }
    //});
  }
  function reset() {
    setAssetInfo([]); setTag(''); setAssetEndDate(''); setAssetOtherEndDate(''); setPutToUseDate('');
    setParentTag(''); setAssetInuseDate(); setTypeOfDepreciation(''); setRecordStartDate('');
    setDepreciationRate(''); setOtherDepreciationRate(''); setTypeOfAsset(''); setassetcode(''); setassetac('');
    setfnclassification(''); setClassOfAsset(''); setFinalAsset(''); setIsTaxCapitalized('');
    setIs100PercDepreciable(''); setPreCapitalizedAssetValue(''); setIsAnyOtherAccgGaapApplicable('');
    setIgaapLimitAmount(''); setOthergaapLimitAmount(''); setSalvageValue(''); setIGaapCapitalizedValue('');
    setTotalCostWithoutTax(''); setTotalCostWithoutTax_tmp(''); setOthergaapCapitalizedValue(''); setTypeofDepShow(false);
    setPreDepType(''); setCapitalizationStatus(''); setValueofAsset('');
  }
  const getTagInfo = function () {
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'param_data': { 'tag': tag },
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData3 = { 'token': EncryptData }

    searchSingleCapitalize(oData3).then(function (res) {
      if (res?.data?.data) {
        setErrMsg('');
        var { capitalizeInfo } = res.data.data;
        setCapitalizationStatus(capitalizeInfo.capitalization_status);

        if (capitalizeInfo.tag) {
          setTag(capitalizeInfo.tag);
          setAssetInfo(capitalizeInfo);

          //Check if parent Tag is exist then 
          if (capitalizeInfo.parent_tag) {
            setParentTag(capitalizeInfo.parent_tag);
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
              'param_data': { 'tag': capitalizeInfo.parent_tag, 'sl_no': capitalizeInfo.sl_no },
              'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData4 = { 'token': EncryptData }
            getSingleCapitalize(oData4).then(function (res2) {

              if (res2?.data?.data) {
                var assetInfo2 = res2.data.data.capitalizeInfo;
                setAssetEndDate(getFormatedDate(assetInfo2.depreciation_end_date));
                setAssetOtherEndDate(getFormatedDate(assetInfo2.depreciation_other_end_date));
                setDepreciationRate(assetInfo2.depreciation_rate);
                setOtherDepreciationRate(assetInfo2.other_depreciation_rate);
                setPreDepType(assetInfo2.type_of_depreciation);
                setTypeOfDepreciation(assetInfo2.type_of_depreciation);
                if (assetInfo2.cap_type_of_asset == "Specify") {
                  if (assetInfo2.class_of_asset === 'Capitalized') {
                    setAssetInuseDate(assetInfo2.asset_in_use_date ? (new Date(new Date(assetInfo2.asset_in_use_date))) : '');
                    setRecordStartDate(assetInfo2.record_start_date ? (new Date(new Date(assetInfo2.record_start_date))) : '');
                    setOldRecordStartDate(assetInfo2.record_start_date ? (new Date(new Date(assetInfo2.record_start_date))) : '');
                    setOtherRecordStartDate(assetInfo2.other_record_start_date ? (new Date(new Date(assetInfo2.other_record_start_date))) : '');
                    setPutToUseDate(assetInfo2.put_to_use_date ? (new Date(new Date(assetInfo2.put_to_use_date))) : '');
                  }
                } else {
                  if (capitalizeInfo.class_of_asset === 'Capitalized') {
                    setAssetInuseDate(capitalizeInfo.asset_in_use_date ? (new Date(new Date(capitalizeInfo.asset_in_use_date))) : '');
                    setRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
                    setOldRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
                    setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (new Date(new Date(capitalizeInfo.other_record_start_date))) : '');
                    setPutToUseDate(capitalizeInfo.put_to_use_date ? (new Date(new Date(capitalizeInfo.put_to_use_date))) : '');
                  }
                }
                setClassOfAsset(assetInfo2.class_of_asset);
                setassetcode(capitalizeInfo.accounting_code ? capitalizeInfo.accounting_code : assetInfo2.accounting_code);
                setassetac(capitalizeInfo.accounting_name ? capitalizeInfo.accounting_name : assetInfo2.accounting_name);
                setfnclassification(assetInfo2.financials_classification);
              }
            });
          } else {
            if (capitalizeInfo.asset_in_use_date && (capitalizeInfo.class_of_asset === 'Capitalized')) {
              let asset_end_date = new Date(capitalizeInfo.asset_in_use_date);
              let assetend_date = new Date(asset_end_date.setFullYear(asset_end_date.getFullYear() + capitalizeInfo.depreciation_rate));
              let assetenddate = new Date(assetend_date.setDate(assetend_date.getDate() - 1));
              //console.log(assetenddate);
              setAssetEndDate(getFormatedDate(assetenddate));
              setAssetOtherEndDate(getFormatedDate(assetotherenddate));
            }
            setTypeofDepShow(true);
            setDepreciationRate(capitalizeInfo.depreciation_rate);
            setOtherDepreciationRate(capitalizeInfo.other_depreciation_rate);
            setTypeOfDepreciation(capitalizeInfo.type_of_depreciation);
            //setAssetInuseDate(assetinusedate?(new Date(capitalizeInfo.asset_in_use_date)):'');
            if (capitalizeInfo.asset_in_use_date && (capitalizeInfo.class_of_asset === 'Capitalized')) {
              setAssetInuseDate(capitalizeInfo.asset_in_use_date ? (new Date(new Date(capitalizeInfo.asset_in_use_date))) : '');
              setRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
              setOldRecordStartDate(capitalizeInfo.record_start_date ? (new Date(new Date(capitalizeInfo.record_start_date))) : '');
              setOtherRecordStartDate(capitalizeInfo.other_record_start_date ? (new Date(new Date(capitalizeInfo.other_record_start_date))) : '');
              setPutToUseDate(capitalizeInfo.put_to_use_date ? (new Date(new Date(capitalizeInfo.put_to_use_date))) : '');
            }
            // setAssetEndDate(capitalizeInfo.depreciation_end_date);
            setClassOfAsset(capitalizeInfo.class_of_asset);
            setfnclassification(capitalizeInfo.financials_classification);
            setassetcode(capitalizeInfo.accounting_code);
            setassetac(capitalizeInfo.accounting_name);
            //console.log("astinfo3");
          }

          setCapitalizationStatus(capitalizeInfo.capitalization_status);
          setTypeOfAsset(capitalizeInfo.cap_type_of_asset);
          setFinalAsset(capitalizeInfo.capitalization_flag);
          setIsTaxCapitalized(capitalizeInfo.is_tax_capitalized);
          setInvoiceCurrency(capitalizeInfo.invoice_currency);
          setexchangerate(capitalizeInfo.cap_exchange_rate ? parseFloat(capitalizeInfo.cap_exchange_rate).toFixed(2) : parseFloat(capitalizeInfo.exchange_rate).toFixed(2));
          setIs100PercDepreciable(capitalizeInfo.is_100_perc_depreciable);
          setIs100PercOtherDepreciable(capitalizeInfo.is_100_perc_other_depreciable);

          setTotalCostWithoutTax((parseFloat(capitalizeInfo.total_cost_without_tax) || 0).toFixed(2));
          setTotalCostWithoutTax_tmp((parseFloat(capitalizeInfo.total_cost_without_tax) || 0).toFixed(2));

          if (capitalizeInfo.is_tax_capitalized == 'No') {
            setPreCapitalizedAssetValue(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
            setPreCapitalizedAssetValue_tmp(parseFloat(capitalizeInfo.pre_capitalized_asset_value).toFixed(2));
            setIGaapCapitalizedValue((parseFloat(capitalizeInfo.igaap_capitalized_value ? capitalizeInfo.igaap_capitalized_value : capitalizeInfo.total_cost_without_tax) || 0).toFixed(2));
          } else {
            setPreCapitalizedAssetValue(capitalizeInfo.value_of_asset);
            setPreCapitalizedAssetValue_tmp((parseFloat(capitalizeInfo.value_of_asset) || 0).toFixed(2));
            setIGaapCapitalizedValue((parseFloat(capitalizeInfo.igaap_capitalized_value) || 0).toFixed(2));
          }
          setIsAnyOtherAccgGaapApplicable(capitalizeInfo.is_any_other_accg_gaap_applicable);
          setShowOtherVal(capitalizeInfo.is_any_other_accg_gaap_applicable);
          setIgaapLimitAmount((parseFloat(capitalizeInfo.igaap_limit_amount) || 0).toFixed(2));
          setOthergaapLimitAmount((parseFloat(capitalizeInfo.othergaap_limit_amount) || 0).toFixed(2));
          setSalvageValue((parseFloat(capitalizeInfo.salvage_value) || 0).toFixed(2));
          //setIGaapCapitalizedValue(capitalizeInfo.igaap_capitalized_value);
          setOthergaapCapitalizedValue((parseFloat(capitalizeInfo.othergaap_capitalized_value) || 0).toFixed(2));
          //setCompRefNo(capitalizeInfo.comp_ref_no);
          setValueofAsset((parseFloat(capitalizeInfo.value_of_asset) || 0).toFixed(2));
          //setValueWithTax(capitalizeInfo.value_with_tax);
          setDeemedCost(parseFloat(capitalizeInfo.deemed_cost || 0).toFixed(2));
          //alert(capitalizeInfo.indas_effective_date);
          setIndAsEffectiveDate(capitalizeInfo.indas_effective_date ? (new Date(new Date(capitalizeInfo.indas_effective_date))) : '');
          if (capitalizeInfo.capitalization_status == 'Y') {
            setCINAndRef(capitalizeInfo.cin_no);
            setAllReadOnly(true);
            setCoaReadOnly(false);

          } else { setAllReadOnly(false); }
        }

      } else { setErrMsg('Assets Not Found'); }
    });
  }

  const setOldAssetauditInfo = function (auditInfo) {
    var AuditOldData = {
      'tag': auditInfo.tag,
      'cin_no': CINAndRef,
      'asset_in_use_date': (auditInfo.asset_in_use_date ? getFormatedDate(auditInfo.asset_in_use_date) : ''),
      'type_of_depreciation': auditInfo.type_of_depreciation,
      'depreciation_rate': auditInfo.depreciation_rate,
      'other_depreciation_rate': auditInfo.other_depreciation_rate,
      'class_of_asset': auditInfo.class_of_asset,
      'accounting_code': auditInfo.accounting_code,
      'accounting_name': auditInfo.accounting_name,
      'financials_classification': auditInfo.financials_classification,
      'record_start_date': (auditInfo.record_start_date ? getFormatedDate(auditInfo.record_start_date) : ''),
      'put_to_use_date': (auditInfo.put_to_use_date ? getFormatedDate(auditInfo.put_to_use_date) : ''),
      //'final_asset':finalAsset,
      'cap_exchange_rate': auditInfo.cap_exchange_rate ? parseFloat(auditInfo.cap_exchange_rate).toFixed(2) : parseFloat(0.00).toFixed(2),
      'capitalization_flag': auditInfo.capitalization_flag,
      'is_tax_capitalized': auditInfo.is_tax_capitalized,
      'is_100_perc_depreciable': auditInfo.is_100_perc_depreciable,
      'is_100_perc_other_depreciable': auditInfo.is_100_perc_other_depreciable,
      'pre_capitalized_asset_value': auditInfo.pre_capitalized_asset_value ? parseFloat(auditInfo.pre_capitalized_asset_value).toFixed(2) : parseFloat(0.00).toFixed(2),
      'is_any_other_accg_gaap_applicable': auditInfo.is_any_other_accg_gaap_applicable,
      'igaap_limit_amount': auditInfo.igaap_limit_amount ? parseFloat(auditInfo.igaap_limit_amount).toFixed(2) : parseFloat(0.00).toFixed(2),
      'othergaap_limit_amount': auditInfo.othergaap_limit_amount ? parseFloat(auditInfo.othergaap_limit_amount).toFixed(2) : parseFloat(0.00).toFixed(2),
      'salvage_value': auditInfo.salvage_value ? parseFloat(auditInfo.salvage_value).toFixed(2) : parseFloat(0.00).toFixed(2),
      'igaap_capitalized_value': auditInfo.igaap_capitalized_value ? parseFloat(auditInfo.igaap_capitalized_value).toFixed(2) : parseFloat(0.00).toFixed(2),
      'othergaap_capitalized_value': auditInfo.othergaap_capitalized_value ? parseFloat(auditInfo.othergaap_capitalized_value).toFixed(2) : parseFloat(0.00).toFixed(2),
      'deletion_status': auditInfo.deletion_status,
      'cap_type_of_asset': auditInfo.cap_type_of_asset,
      'depreciation_end_date': auditInfo.depreciation_end_date,
      'depreciation_other_end_date': auditInfo.depreciation_other_end_date,
      'capitalization_status': auditInfo.capitalization_status,
      //'comp_ref_no':compRefNo,
      'value_of_asset': parseFloat(auditInfo.value_of_asset).toFixed(2),
      //'value_with_tax':valuewithtax
      'other_record_start_date': ((auditInfo?.other_record_start_date) ? getFormatedDate(auditInfo.other_record_start_date) : ''),

      'indas_effective_date': ((auditInfo?.indas_effective_date) ? getFormatedDate(auditInfo.indas_effective_date) : ''),
      'deemed_cost': auditInfo.deemed_cost,
      'company_id': auditInfo.company_id,
      'division_id': auditInfo.division_id,
      'created_by': auditInfo.created_by,
    };
    setAuditInfo(AuditOldData);
  }
  const igaapLimitAmount_handler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setIgaapLimitAmount(parseFloat(e.target.value));
    calIgaapLimitAmount(parseFloat(e.target.value));
  }
  const calIgaapLimitAmount = function (value) {
    if (preCapitalizedAssetValue <= value) {
      //setFinalAsset("No");
      setIGaapCapitalizedValue(parseFloat(igaapLimitAmount) - parseFloat(salvageValue));
    } else {
      setIGaapCapitalizedValue(totalcostwithouttax);
    }
  }
  const handleTypeAsset = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    //alert(value);
    setTypeOfAsset(e.target.value);
    //if(assettype="Specify"){}

    //calIGaapCapitalizedValue(value);
  }
  const handleTypeDepreciation = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setTypeOfDepreciation(e.target.value);
    //calIGaapCapitalizedValue(value);
  }
  const handleClassOfAsset = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setClassOfAsset(e.target.value);
    if (value != "Capitalized") {
      setFinalAsset("NO");
      setAllReadOnly(true);
    } else {
      setFinalAsset("YES");
      setAllReadOnly(false);
    }
    //calIGaapCapitalizedValue(value);
  }
  const handle_enddate = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setDepreciationRate(value);
    if (value >= 0) {
      if (parentTag !== '' && assettype === "Specify") {
        //end date will be same
      } else {
        //for child
        let asset_end_date = new Date(assetinusedate);  //console.log(asset_end_date.getFullYear()+parseInt(value));
        let assetend_date = new Date(asset_end_date.setFullYear((asset_end_date.getFullYear() + parseInt(value))));
        //console.log(assetend_date);
        let assetenddate = new Date(assetend_date.setDate(assetend_date.getDate() - parseInt(1)));
        //console.log(assetenddate);
        setAssetEndDate(getFormatedDate(assetenddate));
      }
    } else { setAssetEndDate(''); }
  }
  const handle_other_enddate = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setOtherDepreciationRate(value);
    if (value >= 0) {
      if (parentTag !== '' && assettype === "Specify") {
        //end date will be same
      } else {
        //for child
        let other_end_date = new Date(assetinusedate);  //console.log(asset_end_date.getFullYear()+parseInt(value));
        let asset_other_end_date = new Date(other_end_date.setFullYear((other_end_date.getFullYear() + parseInt(value))));
        //console.log(assetend_date);
        let assetotherenddate = new Date(asset_other_end_date.setDate(asset_other_end_date.getDate() - parseInt(1)));
        //console.log(assetenddate);
        setAssetOtherEndDate(getFormatedDate(assetotherenddate));
      }
    } else { setAssetOtherEndDate(''); }
  }
  const handle_fnclassification = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setfnclassification(e.target.value);
  }
  const exchangerate_handler = (e) => {
    setexchangerate(e.target.value);
    calInvValInrExRate();
  }
  const calInvValInrExRate = () => { //alert((parseFloat(invoicevaluefx)));
    setPreCapitalizedAssetValue((parseFloat(preCapitalizedAssetValue_tmp)) * (parseFloat(exchangerate)));
    if (isTaxCapitalized == "Yes") {
      setIGaapCapitalizedValue((parseFloat(preCapitalizedAssetValue_tmp)) * (parseFloat(exchangerate)));
      setTotalCostWithoutTax(parseFloat(totalcostwithouttax_tmp) * parseFloat(exchangerate));
    } else {
      setIGaapCapitalizedValue(parseFloat(totalcostwithouttax_tmp) * parseFloat(exchangerate));
      setTotalCostWithoutTax(parseFloat(totalcostwithouttax_tmp) * parseFloat(exchangerate));
      //alert(totalcostwithouttax);
    }
    //setIGaapCapitalizedValue( (parseFloat(iGaapCapitalizedValue)) * (parseFloat(exchangerate))  );
  }
  const calIGaapCapitalizedValue = (e) => {
    let value = e.target.value; //alert(value);
    //if(value!="Capitalized"){
    if (value == "Yes") {
      //setIsTaxCapitalized("NO"); 
      setIsTaxCapitalized("Yes");
      setIGaapCapitalizedValue(preCapitalizedAssetValue);
    } else {
      setIsTaxCapitalized("No");
      //setIsTaxCapitalized("YES");
      setIGaapCapitalizedValue(totalcostwithouttax);
    }
  }
  const calIsAnyOtherAccgGaapApplicable = (e) => {
    let value = e.target.value; //alert(value);
    setShowOtherVal(value);
    setIsAnyOtherAccgGaapApplicable(value);
  }
  const handleSubmit = async (e) => {
    e.preventDefault(); var valid_Name = true;

    if (!classOfAsset || !TEXT_REGEX.test(classOfAsset)) {
      setErrClassOfAsset('Class Of Asset is required'); valid_Name = false;
      //return;
    } else {
      setErrClassOfAsset(''); //alert(classOfAsset); 
    }
    if (!allreadOnly) { //check validation if not capitalized 
      if (!puttousedate || puttousedate === '') {
        setErrPutToUseDate('Put To Use Date is required'); valid_Name = false;
        //return;
      } else {
        setErrPutToUseDate(''); //alert('1'); 
      }
      if (!assettype || assettype === '') {
        //Type of asset
        setErrTypeOfAsset('Depreciation mode is required'); valid_Name = false;
        //return;
      } else {
        setErrTypeOfAsset(''); //alert('1'); 
      }
      if (!depreciationtype || depreciationtype === '') {
        setErrDepreciationType('Type of depreciation is required'); valid_Name = false;
        //return;
      } else {
        setErrDepreciationType(''); //alert('1'); 
      }

      if (!recordstartdate || recordstartdate === '') {
        setErrRecordStartDate('Record start date is required'); valid_Name = false; //alert('1');
        //return;
      } else {
        setErrRecordStartDate(''); //alert(recordstartdate);
      }
      if (!assetinusedate || assetinusedate === '') {
        setErrAssetInuseDate('Asset in use date is required'); valid_Name = false;
        //return;
      } else {
        setErrAssetInuseDate(''); //alert('1'); 
      }
      // Compare only if both dates are present
      if (recordstartdate && assetinusedate) {
        const start = new Date(recordstartdate);
        const inUse = new Date(assetinusedate);

        if (start < inUse) {
          setErrRecordStartDate("Record start date cannot be earlier than Asset in use date");
          valid_Name = false;
        }
      }
      if ((showOtherVal !== '' && showOtherVal == 'Yes') && (!otherrecordstartdate || otherrecordstartdate === '')) {
        setErrOtherRecordStartDate('Record start date[Other-GAAP] is required'); valid_Name = false; //alert('1');
        //return;
      } else {
        setErrOtherRecordStartDate(''); //alert(recordstartdate);
      }
      if (!assetac || !TEXT_SPCL_REGEX.test(assetac)) {
        setErrAssetAc('Accounting Name of the Asset is required'); valid_Name = false;
        //return;
      } else {
        setErrAssetAc('');  //alert('2');
      }
      if (!fnclassification || !TEXT_REGEX.test(fnclassification)) {
        setErrFnClassification('Financials Classification is required'); valid_Name = false;
        //return;
      } else {
        setErrFnClassification('');  //alert('3');
      }

      if (!depreciationtype || !TEXT_REGEX.test(depreciationtype)) {
        setErrDepreciationType('Depreciation type is required'); valid_Name = false;
        //return;
      } else {
        setErrDepreciationType('');  //alert('4'); 
      }

      if (!depreciationrate || !NUMBER_REGEX.test(depreciationrate)) {
        setErrDepreciationRate('Depreciation Rate(No. of years) [I-GAAP] is required'); valid_Name = false;
        //return;
      } else {
        setErrDepreciationRate(''); //alert('5');
      }
      if ((showOtherVal !== '' && showOtherVal == 'Yes') && (!otherdepreciationrate || !NUMBER_REGEX.test(otherdepreciationrate))) {
        setErrOtherDepreciationRate('Depreciation Rate(No. of years) [Other-GAAP] is required'); valid_Name = false;
        //return;
      } else {
        setErrOtherDepreciationRate(''); //alert('5');
      }
      if (!finalAsset || !TEXT_REGEX.test(finalAsset)) {
        setErrFinalAsset('Final Asset is required'); valid_Name = false;
        //return;
      } else {
        setErrFinalAsset(''); //alert('7'+valid_Name); 
      }
      if (!isTaxCapitalized || !TEXT_REGEX.test(isTaxCapitalized)) {
        setErrIsTaxCap('Is Tax Capitalized is required'); valid_Name = false; //alert('8'+isTaxCapitalized);
        //return;
      } else {
        setErrIsTaxCap(''); //alert('8'+valid_Name); 
      }
      if (!TEXT_REGEX.test(exchangerate)) {
        setErrExchangeRate('Exchange rate is required'); valid_Name = false; //alert('11');
        //return;
      } else { setErrExchangeRate(''); }
      if (!is100PercDepreciable || !TEXT_REGEX.test(is100PercDepreciable)) {
        setErrIs100PercDep('Is 100% Depreciable Asset [I-GAAP] is required'); valid_Name = false;
        //return;
      } else {
        setErrIs100PercDep(''); //alert('9'+valid_Name); 
      }
      if ((showOtherVal !== '' && showOtherVal == 'Yes') && (!is100PercOtherDepreciable || !TEXT_REGEX.test(is100PercOtherDepreciable))) {
        setErrIs100PercOthDep('Is 100% Depreciable Asset [Other-GAAP] is required'); valid_Name = false;
        //return;
      } else {
        setErrIs100PercOthDep(''); //alert('9'+valid_Name); 
      }
      if (!preCapitalizedAssetValue === null || !TEXT_REGEX.test(preCapitalizedAssetValue)) {
        setErrPreCapAsVal('Pre Capitalized Asset Value is required'); valid_Name = false;
        //return;
      } else {
        setErrPreCapAsVal(''); //alert('10'+valid_Name); 
      }
      /*if (!isAnyOtherAccgGaapApplicable && igaapLimitAmount=== null && !TEXT_REGEX.test(isAnyOtherAccgGaapApplicable)) {
        setErrIsAnyOtAcGaApp('Is any other Accg GAAP Applicable is required'); valid_Name=false;
        //return;
      }else{ setErrIsAnyOtAcGaApp(''); //alert('11'+valid_Name); 
      }*/
      if (igaapLimitAmount === null || !TEXT_REGEX.test(igaapLimitAmount)) {
        setErrIgaapLimitAmount('I-GAAP - Limit for 100% Depreciable Asset (Rs) is required'); valid_Name = false;
        //return;
      } else {
        setErrIgaapLimitAmount(''); //alert('12'+igaapLimitAmount); 
      }
      if ((showOtherVal !== '' && showOtherVal == 'Yes') && (othergaapLimitAmount === null || !TEXT_REGEX.test(othergaapLimitAmount))) { //alert(othergaapLimitAmount);
        setErrOthergaapLimitAmount('Other-GAAP - Limit for 100% Depreciable Asset (Rs) is required'); valid_Name = false;
        //return;
      } else {
        setErrOthergaapLimitAmount(''); //alert('13'+valid_Name); 
      }
      if (salvageValue === null || !TEXT_REGEX.test(salvageValue)) {
        setErrSalvageValue('Salvage Value is required'); valid_Name = false;
        //return;
      } else {
        setErrSalvageValue('');  //alert('14'+salvageValue); 
      }
      if (iGaapCapitalizedValue === null || !TEXT_REGEX.test(iGaapCapitalizedValue)) {
        setErrIGaCapValue('Capitalized Value (I-GAAP) is required'); valid_Name = false;
        //return;
      } else {
        setErrIGaCapValue(''); //alert('15'+iGaapCapitalizedValue); 
      }
      if ((showOtherVal !== '' && showOtherVal == 'Yes') && (othergaapCapitalizedValue === null || !TEXT_REGEX.test(othergaapCapitalizedValue))) {
        setErrOthGaCaptValue('Capitalized Value (Other GAAP) is required'); valid_Name = false;
        //return;
      } else { setErrOthGaCaptValue(''); }
    }
    if (valid_Name) { //alert('valid');
      if (Tag !== '' && Tag !== null) {
        if (recordstartdate != oldrecordstartdate) {
          //const userConfirmed = window.confirm("Are you sure you want to clear previous depreciation?");
          //alert(userConfirmed);
          //setClearDepreciation(userConfirmed); // true if user clicked OK, false if Cancel
          //saveData(userConfirmed);
          saveData(false);
        }
      } else {
        saveData(false);
      }
      //submit form
    } else {
      //alert(valid_Name);
      return false;
    }
  }

  const saveData = function (clear) { //alert(isAnyOtherAccgGaapApplicable);
    var data = {
      'tag': tag,
      'cin_no': CINAndRef,
      'asset_in_use_date': (assetinusedate ? getFormatedDate(assetinusedate) : ''),
      'type_of_depreciation': depreciationtype,
      'depreciation_rate': depreciationrate,
      'class_of_asset': classOfAsset,
      'accounting_code': assetcode,
      'accounting_name': assetac,
      'financials_classification': fnclassification,
      'record_start_date': (recordstartdate ? getFormatedDate(recordstartdate) : ''),
      'put_to_use_date': (puttousedate ? getFormatedDate(puttousedate) : ''),
      //'final_asset':finalAsset,
      'cap_exchange_rate': parseFloat(exchangerate).toFixed(2),
      'capitalization_flag': finalAsset,
      'is_tax_capitalized': isTaxCapitalized,
      'is_100_perc_depreciable': is100PercDepreciable,
      'pre_capitalized_asset_value': parseFloat(preCapitalizedAssetValue).toFixed(2),
      'is_any_other_accg_gaap_applicable': isAnyOtherAccgGaapApplicable,
      'igaap_limit_amount': parseFloat(igaapLimitAmount).toFixed(2),
      'salvage_value': parseFloat(salvageValue).toFixed(2),
      'igaap_capitalized_value': parseFloat(iGaapCapitalizedValue).toFixed(2),
      'deletion_status': 'No',
      'cap_type_of_asset': assettype,
      'depreciation_end_date': assetenddate,
      'capitalization_status': 'Y',
      //'comp_ref_no':compRefNo,
      'value_of_asset': parseFloat(valueofasset).toFixed(2),
      //'value_with_tax':valuewithtax
      'indas_effective_date': (indAsEffectiveDate ? getFormatedDate(indAsEffectiveDate) : null),
      'deemed_cost': parseFloat(deemedCost).toFixed(2),
      'clear_Depreciation': clear,
      'company_id': sessionStorage.getItem('LoggedInCompanyId'),
      'division_id': sessionStorage.getItem('LoggedInDivisionId'),
      'created_by': sessionStorage.getItem('LoggedInUserId'),
    };
    if (isAnyOtherAccgGaapApplicable == 'Yes') {
      data.other_record_start_date = ((otherrecordstartdate != '') ? getFormatedDate(otherrecordstartdate) : '');
      data.other_depreciation_rate = otherdepreciationrate;
      data.depreciation_other_end_date = ((assetotherenddate != '') ? getFormatedDate(assetotherenddate) : '');;
      data.is_100_perc_other_depreciable = is100PercOtherDepreciable;
      data.othergaap_capitalized_value = othergaapCapitalizedValue;
      data.othergaap_limit_amount = othergaapLimitAmount;
    } //alert(clearDepreciation);
    //console.log('depreciationtype');console.log(data);
    if (capitalizeInfo.type_of_depreciation !== '' && capitalizeInfo.type_of_depreciation !== null) {
      var objAudit = { 'audit_module': 'Finance Operation', 'audit_method': 'updated', 'audit_tag': tag, 'old_values': auditInfo, 'new_values': data }
    } else {
      var objAudit = { 'audit_module': 'Finance Operation', 'audit_method': 'created', 'audit_tag': tag, 'old_values': '', 'new_values': data }
    }
    try {
      console.log(data); //alert('abc'); 
      //const response = saveData();
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': data, 'audit_params': objAudit,
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData5 = { 'token': EncryptData }
      saveCapitalize(oData5).then(function (res) {
        /*getAssets().then(res=>{
          if(res?.data?.data?.length) setItems(res.data.data);
        })*/
        if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
          setErrMsg(res.data.message); setSuccess(false);
        } else {
          setSuccess(res.data.message); setDisabled(true); setErrMsg(false); reset();
          setErrTag(''); setErrAssetInuseDate(''); setDepreciationRate(''); setOtherDepreciationRate(''); setErrAssetAc(''); setErrFnClassification('');
          setErrClassOfAsset(''); setErrFinalAsset(''); setErrIsTaxCap(''); setIs100PercDepreciable('');
          setErrPreCapAsVal(''); setErrIsAnyOtAcGaApp(''); setErrIgaapLimitAmount(''); setErrOthergaapLimitAmount('');
          setErrSalvageValue(''); setErrIGaCapValue(''); setErrOthGaCaptValue('');
        }
      });
      //elementRef.current.focus();
    } catch (err) {
      setSuccess(false); setErrMsg(err.data.message);
      if (!err?.data) {
        console.log(err);
        setErrMsg('No Server Response');
      } else if (err.data?.status === 409) {
        setErrMsg('Username Taken');
      } else {
        setErrMsg('Insert/Update Failed');
      }
      //elementRef.current.focus();
    }
  }

  return (
    <div className='al-page' id="all-asset-list-page">
      {/* Header Section */}
      {/* ══ PAGE HEADER ══ */}
      <div className="al-page-header">
        <div className="al-page-header-left">
          <div className="al-page-header-icon">
            <i className="bi bi-bar-chart-steps" />
          </div>
          <div className="al-page-header-text">
            <h5 className="al-page-title">Single Capitalization</h5>
            <p className="al-page-subtitle">Manage asset capitalization details and depreciation settings</p>
          </div>
        </div>
        {capitalization_status && (
          <span className={`status-badge ${capitalization_status === 'Y' ? 'capitalized' : 'pending'}`}>
            <i className={`bi ${capitalization_status === 'Y' ? 'bi-check-circle-fill' : 'bi-clock'}`} />
            {capitalization_status === 'Y' ? 'Capitalized' : 'Pending'}
          </span>
        )}
      </div>

      <div className="al-filter-card" id="al-filter-panel">
        <div className="al-filter-card-header">
          <span className="al-filter-card-title">
            <i className="bi bi-search" /> Asset Lookup
          </span>
        </div>
        <div className="al-filter-card-body">

          <div className="al-filter-row" id="al-branch-row">
            {(Tag !== '' && Tag !== null) ? (
              <div className="al-filter-group al-filter-group-wide">
                <label className="al-filter-label"><i className="bi bi-tag-fill" /> TAG</label>
                <div className="al-filter-control-full">
                  <i className="bi bi-bookmark-check-fill" />
                  {capitalizeInfo.tag}
                </div>
                <div />
              </div>
            ) : (
              <div className="al-filter-group al-filter-group-wide">
                <span className="al-filter-label"><i className="bi bi-tag-fill" /> TAG</span>
                <input
                  id="sc-tag-input"
                  type="text"
                  className="al-form-input"
                  placeholder="Enter the asset TAG..."
                  onChange={(e) => setTag(e.target.value)}
                  value={tag}
                />
                <div className="al-filter-actions" id="al-filter-actions">
                  <button className="al-btn al-btn-primary" id="al-search-btn" onClick={getTagInfo}>
                    <i className="bi bi-search" /> Search
                  </button>
                  <a href="/single-asset-capitalization">
                    <button type="button" className="al-btn al-btn-outline">
                      <i className="bi bi-arrow-clockwise" /> Reset
                    </button>
                  </a>
                </div>
              </div>
            )}
          </div>
          {/* CIN Reference */}
          {CINAndRef && (
            <div className="sc-cin-display" id="sc-cin-display">
              <span className="sc-tag-label"> Capitalization ID </span>
              <span className="sc-cin-display-value">{CINAndRef}</span>
            </div>
          )}


        </div>
      </div>
      <div className="al-filter-card">
        <div className="al-filter-card-body">
          {/* ══ ALERTS ══ */}
          {success && (
            <div className="alert alert-success" role="alert">
              <i className="bi bi-check-circle-fill" />
              <span>{success}</span>
            </div>
          )}
          {errMsg && (
            <div className="alert alert-danger" role="alert">
              <i className="bi bi-exclamation-triangle-fill" />
              <span>{errMsg}</span>
            </div>
          )}

          {/* ══ TAG SEARCH ══ */}

          <form onSubmit={handleSubmit} >
            <div className='row single__asset__form'>

              <div className='col-6'>
                <div className="row form-fields"><div className="label col-6"><label> Class of Asset </label><span className="star error"> *</span></div>
                  <div className="col-6">
                    <select onChange={handleClassOfAsset} className="form-select form-select-sm mb-3" disabled={CoaReadOnly ? "disabled" : ""}>
                      <option value="">Select One</option>
                      <option value="Capitalized" selected={(classOfAsset == "Capitalized") ? "selected" : ''}>Capitalized</option>
                      <option value="FOC Asset" selected={(classOfAsset == "FOC Asset") ? "selected" : ''}>FOC Asset</option>
                      <option value="WIP Asset" selected={(classOfAsset == "WIP Asset") ? "selected" : ''}>WIP Asset</option>
                      <option value="Leased Asset" selected={(classOfAsset == "Leased Asset") ? "selected" : ''}>Leased Asset</option>
                      <option value="Opex Asset" selected={(classOfAsset == "Opex Asset") ? "selected" : ''}>Opex Asset</option>
                    </select><span className="invalid-feedback"> {ErrClassOfAsset} </span>
                  </div></div>
              </div>
              <div className='col-6'>
                <FromFieldDate star="*"
                  label="Record Start Date"
                  inputValue={recordstartdate}
                  setInputValue={setRecordStartDate}
                  setErrorMsg={ErrRecordStartDate}
                  readOnly={allreadOnly ? "readonly" : ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FromFieldText  //star="*"
                  label="Parent TAG"
                  inputValue={capitalizeInfo.parent_tag}
                  readOnly={(capitalizeInfo.parent_tag == "undefine") ? '' : "readonly"}

                />
              </div>
              <div className="col-6">
                <div className="row form-fields">
                  <div className="col-6"><label>Depreciation mode <span className="star error"> * </span></label></div>
                  <div className="col-6">
                    <select onChange={handleTypeAsset} className="form-select form-select-sm mb-3" disabled={allreadOnly ? "disabled" : ""}>
                      <option value="">Select One</option>
                      <option value="UseParent" selected={(assettype == "UseParent") ? "selected" : ''}>Use Parent</option>
                      <option value="Specify" selected={(assettype == "Specify") ? "selected" : ''}>Specify</option>
                    </select><span className="invalid-feedback"> {ErrTypeOfAsset} </span></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">

                {(capitalizeInfo.parent_tag != "undefined") ? ((assettype != "UseParent") ? <FromFieldDate star="*"
                  label="Date of Capitalization / Asset Ready To Use"
                  inputValue={assetinusedate}
                  setInputValue={setAssetInuseDate}
                  setErrorMsg={ErrAssetInuseDate}
                  readOnly={allreadOnly ? "readonly" : ""}
                /> : <FromFieldDate
                  label="Date of Capitalization / Asset Ready To Use"
                  inputValue={assetinusedate}
                  setInputValue={setAssetInuseDate}
                  setErrorMsg={ErrAssetInuseDate}
                  readOnly="readonly"
                />) : (
                  <FromFieldDate star="*"
                    label="Date of Capitalization / Asset Ready To Use"
                    inputValue={assetinusedate}
                    setInputValue={setAssetInuseDate}
                    setErrorMsg={ErrAssetInuseDate}
                    readOnly={allreadOnly ? "readonly" : ""}
                  />
                )}
              </div>
              <div className='col-6'>
                {typeofDepShow ? (<div className="row form-fields"><div className="label col-6"><label> Type of Depreciation <span className="star error"> *</span></label></div>
                  <div className="col-6"><select onChange={handleTypeDepreciation} className="form-select form-select-sm mb-3" disabled={(parentTag !== '') ? "true" : (allreadOnly) ? "disabled" : ""}>
                    <option value="">Select One</option>
                    <option value="SLMYMW" selected={(depreciationtype == "SLMYMW") ? "selected" : ''}>SLMY MW</option>
                    <option value="SLMYDW" selected={(depreciationtype == "SLMYDW") ? "selected" : ''}>SLMY DW</option>
                    <option value="SLMPMW" selected={(depreciationtype == "SLMPMW") ? "selected" : ''}>SLMP MW</option>
                    <option value="SLMPDW" selected={(depreciationtype == "SLMPDW") ? "selected" : ''}>SLMP DW</option>
                  </select><span className="invalid-feedback"> {ErrDepreciationType} </span></div></div>
                ) : (<FromFieldText star="*"
                  label="Type of Depreciation"
                  inputValue={preDepType}
                  readOnly="readonly"
                  setErrorMsg={ErrDepreciationType}
                />)}
              </div>
              <div className="col-6">
                <div className="row"><div className="col-md-6">
                  <label> Depreciation Rate(No. of years) [I-GAAP] <span className="star error"> * </span></label>
                </div>
                  <div className="col-md-6">
                    <input type="text" onChange={handle_enddate} value={depreciationrate} className="form-control" placeholder="Depreciation Rate[I-GAAP]" readOnly={(parentTag !== '') ? "readonly" : (allreadOnly) ? "readonly" : ""} />
                    <span className="invalid-feedback">{ErrOtherDepreciationRate}</span>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <FromFieldText  //star="*"
                  label="End Date [I-GAAP]"
                  placeholder="End Date [I-GAAP]"
                  inputValue={assetenddate}
                  setInputValue={setAssetEndDate}
                  //setErrorMsg={ErrDepreciationRate}
                  readOnly="readOnly"
                />
              </div>


            </div>
            <div className='row single__asset__form'>
              <div className='col-6'>
                <FromSpFieldText label="Accounting Code of Asset" //star="*"
                  inputValue={assetcode}
                  setInputValue={setassetcode}
                  readOnly={allreadOnly ? "readonly" : ""}
                />
              </div>
              <div className='col-6'>
                <FromSpFieldText label="Accounting Name of the Asset" star="*"
                  inputValue={assetac}
                  setInputValue={setassetac}
                  setErrorMsg={ErrAssetAc}
                  readOnly={allreadOnly ? "readonly" : ""}
                />
              </div>
            </div>

            <div className='row single__asset__form'>
              <div className='col-6'>
                <div className="row form-fields"><div className="label col-6"><label> Financials Classification </label><span className="star error"> * </span></div>
                  <div className="col-6">
                    <select onChange={handle_fnclassification} className="form-select form-select-sm" disabled={(parentTag !== '') ? "true" : (allreadOnly) ? "disabled" : ""}>
                      <option value="">Select Financials Classification</option>
                      {classifications && classifications.length > 0 ? (
                        classifications.map((option) => (
                          <option value={option.id} selected={(option.id == fnclassification) ? "selected" : ''}>{option.category_name}</option>
                        ))
                      ) : (<option value="">No Data</option>)}
                    </select><span className="invalid-feedback"> {ErrFnClassification} </span>
                  </div>
                </div>
              </div>
              <div className='col-6'>
                <FromFieldDate star="*"
                  label="Put to Use Date [IT]"
                  inputValue={puttousedate}
                  setInputValue={setPutToUseDate}
                  setErrorMsg={ErrPutToUseDate}
                  readOnly={allreadOnly ? "readonly" : ""}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">

                <div className="row form-fields">
                  <div className="label col-6">
                    <label> Final Asset Capitalization Flag </label>
                    <span className="star error"> *</span>
                  </div>
                  <div className="item col-6">
                    <input type="text" name="capitalization_flag" readOnly value={finalAsset} className="form-control" placeholder="Capitalization Flag" />
                    <span className="invalid-feedback"> {ErrFinalAsset} </span>
                  </div>
                </div>

              </div>
              <div className="col-6">
                <div className="row form-fields">
                  <div className="col-6"><label>Is Tax Capitalized <span className="star error"> * </span></label></div>
                  <div className="col-6">
                    <select onChange={calIGaapCapitalizedValue} className="form-select form-select-sm mb-3" disabled={allreadOnly ? "disabled" : ""}>
                      <option value="">Select One</option>
                      <option value="Yes" selected={(isTaxCapitalized == "Yes") ? "selected" : ''}>Yes</option>
                      <option value="No" selected={(isTaxCapitalized == "No") ? "selected" : ''}>No</option>
                    </select><span className="invalid-feedback"> {ErrIsTaxCap} </span></div>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col-6">
                <FromFieldText star="*"
                  label="Invoice Currency"
                  placeholder=""
                  inputValue={invoicecurrency}
                  setInputValue={setInvoiceCurrency}
                  readOnly="readonly"
                />
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-md-6" >
                    <label> Exchange Rate </label>
                    <span className="star error">* </span>
                  </div>
                  <div className="col-md-6" >
                    <input type='number' onChange={exchangerate_handler} name="exchange_rate" value={exchangerate}
                      onBlur={exchangerate_handler} className="form-control" placeholder='Enter the exchange rate' readOnly={allreadOnly ? "readonly" : ""} />
                    <span className="invalid-feedback"> {ErrExchangeRate} </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FromFieldSelect star="*"
                  label="Is 100% Depreciable Asset [I-GAAP]"
                  placeholder="Select Is 100% Depreciable Asset [I-GAAP]"
                  selectedValue={is100PercDepreciable}
                  setSelectedValue={setIs100PercDepreciable}
                  values={["Yes", "No"]}
                  setErrorMsg={ErrIs100PercDep}
                  disabled={allreadOnly ? "disabled" : ""}
                />
              </div>
              <div className="col-6">
                <FromFieldNumber star="*"
                  label="Pre Capitalized Asset Value"
                  placeholder="Pre Capitalized Asset Value"
                  inputValue={preCapitalizedAssetValue}
                  setInputValue={setPreCapitalizedAssetValue}
                  setErrorMsg={ErrPreCapAsVal}
                  readOnly={allreadOnly ? "readonly" : ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="row form-fields">
                  <div className="col-6"><label>Is any other Accg GAAP Applicable</label></div>
                  <div className="col-6">
                    <select onChange={calIsAnyOtherAccgGaapApplicable} className="form-select form-select-sm mb-3" disabled={allreadOnly ? "disabled" : ""}>
                      <option value="">Select One</option>
                      <option value="Yes" selected={(isAnyOtherAccgGaapApplicable == "Yes") ? "selected" : ''}>Yes</option>
                      <option value="No" selected={(isAnyOtherAccgGaapApplicable == "No") ? "selected" : ''}>No</option>
                    </select><span className="invalid-feedback"> {ErrIs100PercDep} </span></div>
                </div>
                {/*<FromFieldSelect 
            label="Is any other Accg GAAP Applicable"
            placeholder="Select Is any other Accg GAAP Applicable"
            selectedValue={isAnyOtherAccgGaapApplicable}
            setSelectedValue={setIsAnyOtherAccgGaapApplicable}
            values={["Yes","No"]}
            disabled={allreadOnly?"disabled":""}
         />*/}

              </div>
              <div className="col-6">
                <FromFieldNumber star="*"
                  label="I-GAAP - Limit for 100% Depreciable Asset (Rs)"
                  placeholder="I-GAAP - Limit for 100% Depreciable Asset (Rs)"
                  inputValue={igaapLimitAmount}
                  setInputValue={setIgaapLimitAmount}
                  setErrorMsg={ErrIgaapLimitAmount}
                  readOnly={allreadOnly ? "readonly" : ""}
                />


              </div>

            </div>

            <div className="row ">
              <div className="col-6">
                <FromFieldNumber star="*"
                  label="Salvage Value"
                  placeholder="Salvage Value"
                  inputValue={salvageValue}
                  setInputValue={setSalvageValue}
                  setErrorMsg={ErrSalvageValue}
                  readOnly={allreadOnly ? "readonly" : ""}
                />

              </div>
              <div className="col-6">
                <FromFieldNumber star="*"
                  label="Capitalized Value (I-GAAP)"
                  placeholder="Capitalized Value (I-GAAP)"
                  inputValue={iGaapCapitalizedValue}
                  setInputValue={setIGaapCapitalizedValue}
                  setErrorMsg={ErrIGaCapValue}
                  readOnly={allreadOnly ? "readonly" : ""}
                />

              </div>
            </div>
            <div className="row ">
              <div className="col-6">
                <FromFieldDate star=""
                  label="Effective Date [Ind AS]"
                  inputValue={indAsEffectiveDate}
                  setInputValue={setIndAsEffectiveDate}
                  setErrorMsg={ErrIndAsEffectiveDate}
                  readOnly={allreadOnly ? "readonly" : ""}
                />

              </div>
              <div className="col-6">
                <FromFieldNumber star=""
                  label="Deemed Cost"
                  placeholder="Deemed Cost"
                  inputValue={deemedCost}
                  setInputValue={setDeemedCost}
                  setErrorMsg={ErrDeemedCost}
                  readOnly={allreadOnly ? "readonly" : ""}
                />

              </div>
            </div>
            {((showOtherVal !== '' && showOtherVal == 'Yes') || (isAnyOtherAccgGaapApplicable !== '' && isAnyOtherAccgGaapApplicable == 'Yes')) ? <div>
              <div className="row">
                <h5>&nbsp;</h5>
                <hr></hr>
                <h5>Other-GAAP</h5>
              </div>
              <div className="row">
                <div className="col-6">
                  <FromFieldDate star="*"
                    label="Record Start Date [Other-GAAP]"
                    inputValue={otherrecordstartdate}
                    setInputValue={setOtherRecordStartDate}
                    setErrorMsg={ErrOtherRecordStartDate}
                    readOnly={allreadOnly ? "readonly" : ""}
                  />

                </div>
                <div className="col-6">
                  <FromFieldSelect star="*"
                    label="Is 100% Depreciable Asset [Other-GAAP]"
                    placeholder="Select Is 100% Depreciable Asset [Other-GAAP]"
                    selectedValue={is100PercOtherDepreciable}
                    setSelectedValue={setIs100PercOtherDepreciable}
                    values={["Yes", "No"]}
                    setErrorMsg={ErrIs100PercOthDep}
                    disabled={allreadOnly ? "disabled" : ""}
                  />

                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="row"><div className="col-md-6">
                    <label> Depreciation Rate(No. of years) [Other-GAAP] <span className="star error"> * </span></label>
                  </div>
                    <div className="col-md-6">
                      <input type="text" onChange={handle_other_enddate} value={otherdepreciationrate} className="form-control" placeholder="Depreciation Rate[Other-GAAP]" readOnly={(parentTag !== '') ? "readonly" : (allreadOnly) ? "readonly" : ""} />
                      <span className="invalid-feedback"> {ErrOtherDepreciationRate} </span>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <FromFieldText  //star="*"
                    label="End Date [Other-GAAP]"
                    placeholder="End Date [Other-GAAP]"
                    inputValue={assetotherenddate}
                    setInputValue={setAssetOtherEndDate}
                    setErrorMsg={ErrDepreciationRate}
                    readOnly="readOnly"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <FromFieldNumber star="*"
                    label="Other-GAAP - Limit for 100% Depreciable Asset (Rs)"
                    placeholder="Other-GAAP - Limit for 100% Depreciable Asset (Rs)"
                    inputValue={othergaapLimitAmount}
                    setInputValue={setOthergaapLimitAmount}
                    setErrorMsg={ErrOthergaapLimitAmount}
                    readOnly={allreadOnly ? "readonly" : ""}
                  />
                </div>
                <div className="col-6">
                  <FromFieldNumber star="*"
                    label="Capitalized Value (Other GAAP)"
                    placeholder="Capitalized Value (Other GAAP)"
                    inputValue={othergaapCapitalizedValue}
                    setInputValue={setOthergaapCapitalizedValue}
                    setErrorMsg={ErrOthGaCaptValue}
                    readOnly={allreadOnly ? "readonly" : ""}
                  />
                </div>
              </div>
            </div> : ('')}
            <div className="row">
              <div className="col-6"></div>
              <div className="col-6">
                {(Tag !== '' && Tag !== null) ? <div><button className="btn btn-primary btn-md" disabled={disabled}>Update</button>&nbsp;&nbsp;<a href={'/assets-capitalization-view?tag=' + Tag} className="btn btn-secondary btn-md">Cancel</a></div>
                  : (capitalization_status == 'N') ? <button className="btn btn-primary btn-md" disabled={disabled}> SAVE </button> : ''
                }
                {/*<button onClick={saveData} className='btn btn-primary btn-md'> SAVE </button>*/}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SACapForm;

